import { SelectOption } from '../components/resource/ResourceFormPage';

export type OptionLoader<T> = (params?: any) => Promise<{ results: T[] }>;

export const makeOptionLoader = <T extends { id: number }>(
  loader: OptionLoader<T>,
  labelSelector: (item: T) => string,
  pageSize: number = 100, // Padrão maior para garantir que apareçam todas as opções
) => {
  return async (query: string): Promise<SelectOption[]> => {
    const response = await loader({ 
      search: query,
      page_size: pageSize,
    });
    return response.results.map((item) => ({
      value: item.id,
      label: labelSelector(item),
    }));
  };
};
